import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';

import { JobRepairDataInterface } from '../interfaces/job-repair-data.interface';
import { UserPublicInterface } from '../../user/interfaces/user-public.interface';
import { UserDto } from '../../user/dto/user.dto';

@Exclude()
export class JobRepairDataDto implements JobRepairDataInterface {
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Supervisor ID',
    description: 'Supervisor ID',
  })
  @Expose()
  supervisorId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'SubdivisionId ID',
    description: 'SubdivisionId ID',
  })
  @Expose()
  subdivisionId?: string | undefined;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Id',
    description: 'The primary key of the resource.',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    title: 'Job Repair Date',
  })
  @Expose()
  jobRepairDate!: Date;

  @ApiProperty({
    title: 'Lot',
    description: 'The lot number/identifier',
  })
  @Expose()
  lot!: string;

  @ApiProperty({
    title: 'Lot',
    description: 'The lot number/identifier',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Lot',
    description: 'The block number/identifier',
  })
  @Expose()
  jobBlock!: string;

  @ApiProperty({
    title: 'Subdivision name',
    description: 'The subdivision name associated with this jobRepair',
  })
  @Expose()
  subDivisionName!: string;

  @ApiProperty({
    title: 'Builder Name',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    title: 'Address1',
  })
  @Expose()
  address1!: string;

  @ApiProperty({
    title: 'Address2',
  })
  @Expose()
  address2!: string;

  @ApiProperty({
    title: 'City',
  })
  @Expose()
  city!: string;

  @ApiProperty({
    title: 'State',
  })
  @Expose()
  state!: string;

  @ApiProperty({
    title: 'Zip code',
  })
  @Expose()
  zip!: string;

  @ApiProperty({
    title: 'Supervisor email',
  })
  @Expose()
  supervisorEmail!: string;

  @ApiProperty({
    title: 'Supervisor full name',
    description: 'The supervisor full name associated with this jobRepair',
  })
  @Expose()
  supervisorName!: string;

  @ApiProperty({
    title: 'Supervisor phone',
    description: 'The supervisor phone associated with this jobRepair',
  })
  @Expose()
  supervisorPhoneNumber!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Region ID',
    description: 'The ID of the region associated with this jobRepair',
  })
  @Expose()
  regionId!: string;

  @ApiProperty({
    title: 'iCal sequence',
  })
  @Expose()
  icalSequence!: number;

  @ApiProperty({
    title: 'Job Repair Description',
  })
  @Expose()
  description!: string;

  @ApiProperty({
    title: 'Logo URL',
  })
  @Expose()
  logoUrl!: string;

  @ApiProperty({
    title: 'Job Repair Date',
  })
  @Expose()
  createAt!: Date;

  @ApiProperty({
    title: 'Repair Type',
  })
  @Expose()
  repairType!: string;

  @ApiProperty({
    title: 'Job Repair Description',
  })
  @Expose()
  jobRepairDescription!: string;

  @ApiProperty({
    title: 'Repair Link',
  })
  @Expose()
  repairLink!: string;

  @ApiProperty({
    title: 'Lot Repair Link',
  })
  @Expose()
  lotReportLink!: string;

  @ApiProperty({
    title: 'Main Text',
  })
  @Expose()
  mainText!: string;

  @ApiProperty({
    title: 'Field coordinator email',
  })
  @Expose()
  fieldCoordinatorEmail!: string;

  @ApiProperty({
    title: 'Po Amount',
  })
  @Expose()
  poAmount!: number;

  @ApiProperty({
    title: 'Repair description',
  })
  @Expose()
  repairDescription!: string;

  @ApiProperty({
    title: 'Today Date',
  })
  @Expose()
  todayDate!: string;

  @ApiProperty({
    title: 'Model Name',
  })
  @Expose()
  modelName!: string;

  @ApiProperty({
    title: 'PO Total Threshold',
  })
  @Expose()
  poTotalThreshold!: string;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'User',
    description: 'The user dto.',
  })
  @Expose()
  subdivisionSupervisors?: UserPublicInterface[];
}
